export const selectAllVisits = state => state.visits.visits;
export const selectVisitsLoading = state => state.visits.isLoading;
export const selectVisitsError = state => state.visits.error;
